import { useState } from "react";
import { useHistory } from "react-router";
import { useAppContext } from "../../context/AuthContext";
import { PublicController, PublicControllerType } from "../../controller/public/PublicController";
import { UserController, UserControllerType } from "../../controller/user/UserController";
import LabelsContext from "../../lang/LabelsContext";
import UserReadDto from "../../model/user/UserDto";
import MessageType from "../../utils/MessageType";
import { handleErrorMessage, useEffectOnce } from "../../utils/Utils";

interface UserServiceType {
  logout: any;
  editUser: any;
  getUser: any;
  user: any;
  countryList: any;
}

export default function UserService(): UserServiceType {
  const { showMessage, authData, deleteAuthData, updateAuthData } = useAppContext();
  const [countryList, setCountryList] = useState<any>([]);

  const { axiosLogout, axiosEditUser, axiosGetUser }: UserControllerType = UserController();

  const { axiosGetCountryList }: PublicControllerType = PublicController();

  const { Labels } = LabelsContext();

  const history = useHistory();

  const [user, setUser] = useState<UserReadDto>();

  useEffectOnce(() => {
    axiosGetCountryList()
      .then((result: any) => {
        setCountryList(result.data);
        getUser();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  });

  const logout = () => {
    axiosLogout()
      .then((result: any) => {
        deleteAuthData();
        history.push("/");
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const editUser = (user: any) => {
    axiosEditUser(user)
      .then((result: any) => {
        const data: any = {
          token: authData!.token,
          user: result.data,
        };
        updateAuthData(data);
        showMessage(Labels.EDIT_USER_SUCCESS, MessageType.SUCCESS);
        history.push("/");
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const getUser = () => {
    axiosGetUser()
      .then((result: any) => {
        setUser(result.data);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  return { logout, editUser, getUser, user, countryList };
}

export type { UserServiceType };
